import React from 'react'
import OEIInput from './OEIInput';
import './OEIPopover.css'
import OEICheckBox from './OEICheckBox'
import OEIButton from './OEIButton';
import { EMPTY, FIRSTNAME, LASTNAME } from './Constants';
export default function NewUserPopover(props) {

    const setFirstName = (e) => {
        props.setNewData({ ...props.newData, firstName: e });
        props.setErrors({...props.errors,error1:EMPTY})
    }
    const setLastName = (e) => {
        props.setNewData({ ...props.newData, lastName: e });
        props.setErrors({...props.errors,error2:EMPTY})
    }
    const setEmail = (e) => {
        props.setNewData({ ...props.newData, email: e });
        props.setErrors({...props.errors,error3:EMPTY})

    }
    return (
        <>
            <OEIInput value={props.newData.firstName} newData={props.newData} setValue={setFirstName} name='firstName' label={FIRSTNAME} errorMessage={props.errors.error1} showError='false'></OEIInput>
            <OEIInput value={props.newData.lastName} newData={props.newData} setValue={setLastName} name='lastName' label={LASTNAME} errorMessage={props.errors.error2} ></OEIInput>
            <OEIInput value={props.newData.email} newData={props.newData} setValue={setEmail} name='email' label='Email' errorMessage={props.errors.error3} ></OEIInput>
            {/* {props.generate?        ( <div style={{ display: 'flex', justifyContent: 'center',}} >
            <OEIButton labelName='Generate password' onclick={()=>props.handleClickGenerate()}></OEIButton></div>):<div>
            <OEIInput copyIcon={true} value={props.newUserData.password} label='Password' readOnly='true'></OEIInput>
            </div>
            }    */}
       <OEICheckBox></OEICheckBox>
       
        </>
    )
}
